import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';
import { Button as MaterialButton } from '@mui/material';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

type Props = {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
};

const StyledMaterialButton = styled(MaterialButton)`
    background-color: ${getColor('white')};
    border: 1px solid ${getColor('lightBorderColor')};
    border-radius: 8px;
    text-transform: none;
    padding: 3px 3px;
    font-weight: 550;
    font-size: 12px;
    & span {
        text-align: center;
        text-transform: none;
        color: ${getColor('blue')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('input')};
        line-height: ${getLineHeight('smaller')};
        padding: 3px;
    }
    &:hover {
        border-color: ${getColor('blue')};
    }
    &:disabled {
        & .MuiButton-label {
            color: #A6A6A6;
        }
        background-color: #E0E0E0;
    }
`;

export const Button: React.FC<Props> = ({ label, onClick = _.noop, disabled }) => (
    <StyledMaterialButton onClick={onClick} disabled={disabled}>{label}</StyledMaterialButton>
);
